<script setup>
import { ref, computed } from 'vue'
import { useGlobalStore } from '@stores/global.js'
import Arrow from '@components/global/accents/Arrow.vue'

const global = useGlobalStore()

const linkGroups = computed(() => [
	{
		title: 'Sitemap',
		links: [...global.navigation.map((link) => ({ title: link.title, to: link.to }))],
	},
	{
		title: 'Socials',
		links: [
			{
				title: 'Behance',
				href: 'https://behance.com/papercrowns',
			},
			{
				title: 'LinkedIn',
				href: 'https://www.linkedin.com/company/papercrowns',
			},
			{
				title: 'X / Twitter',
				href: 'https://www.x.com/papercrowns',
			},
			{
				title: 'Instagram',
				href: 'https://www.instagram.com/papercrowns',
			},
		],
	},
	{
		title: 'Legal',
		links: [...global.policyPages.map((policy) => ({ title: policy.title, to: { name: 'policy', params: { slug: policy.slug } } }))],
	},
])
</script>

<template>
	<footer class="relative bg-crowns-dark-grey">
		<!-- Arrow -->
		<div class="relative flex justify-center">
			<Arrow class="absolute -top-10 z-20 lg:-top-[2.85rem]" direction="up" :to="{ params: { top: true } }" />
		</div>
		<div class="relative -mt-5 overflow-hidden md:-mt-0">
			<!-- Reimagine Everything -->
			<img class="absolute -bottom-40 -right-10 h-96 object-contain md:-bottom-24" src="https://cdn.papercrowns.com/website/images/elements/lockups/reimagine-everything-footer.png" alt="Reimagine Everything" />

			<!-- Content -->
			<div class="container">
				<div class="relative flex w-full flex-col gap-10 pb-5 xs:gap-20 sm:gap-16 md:pb-16">
					<div class="flex w-full">
						<div class="flex flex-grow grid-cols-12 flex-col gap-5 xs:grid xs:gap-10">
							<div v-for="group in linkGroups" class="flex flex-col gap-2 xs:col-span-4 xs:gap-4 sm:col-span-3 lg:col-span-2">
								<p class="font-bold text-crowns-off-white">{{ group.title }}</p>
								<ul class="flex flex-wrap gap-3 xs:flex-col xs:gap-2 md:gap-4">
									<li v-for="link in group.links">
										<a class="text-crowns-castle-stone transition-colors duration-200 hover:text-crowns-off-white" :href="link.href" v-if="link.href" target="_blank">
											{{ link.title }}
										</a>
										<router-link class="text-crowns-castle-stone transition-colors duration-200 hover:text-crowns-off-white" :to="link.to" v-else>
											{{ link.title }}
										</router-link>
									</li>
								</ul>
							</div>
						</div>
						<a class="hidden font-medium text-crowns-off-white md:block" href="mailto:hello@papercrowns.com">hello@papercrowns.com</a>
					</div>
					<div class="flex flex-col justify-between gap-5 sm:gap-10 md:flex-row">
						<div class="flex flex-shrink-0 flex-col justify-end text-xs text-crowns-castle-stone sm:text-sm">
							<div>&copy; {{ new Date().getFullYear() }} Paper Crowns&trade; All rights reserved.</div>
							<div>All trademarks and content are the property of their respective owners.</div>
						</div>
						<div class="flex items-center justify-end">
							<div class="absolute right-24 text-sm font-medium leading-[1.15] sm:right-36 sm:text-base">
								<div>Designed and Developed</div>
								<div>by Paper Crowns&trade; &copy;{{ new Date().getFullYear() }}</div>
							</div>
							<img class="h-20 sm:h-32" src="https://cdn.papercrowns.com/website/images/elements/letter/seal-grey.svg" alt="Paper Crowns Seal" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>
